<template>
    <ViewCover style="height: 100%">
        <Breadcrumb>
            <!-- class="d-flex justify-center" :style="`display: ${ $route.name !== 'Guest' || $route.name == 'NewGuest' ? 'none !important' : 'block' }`" -->
            <div id="guest_actions">
            </div>
        </Breadcrumb>
        <v-container fluid class="px-1">
            <KeepAlive exclude="Guest">
                <v-card>
                    <router-view/>
                </v-card>
            </KeepAlive>
        </v-container>
    </ViewCover>
</template>

<script>
import ViewCover from './ViewCover.vue';
import Breadcrumb from '../components/common/Breadcrumb.vue';
export default{
    components:{
        ViewCover,
        Breadcrumb
    }
}
</script>

   